import request from '@/utils/request'

export function addContents(data) {
  return request({
    url: '/v1/contents/contact',
    method: 'post',
    data
  })
}
